import { render, staticRenderFns } from "./Zhuizong.vue?vue&type=template&id=1794ac92&scoped=true&"
import script from "./Zhuizong.vue?vue&type=script&lang=js&"
export * from "./Zhuizong.vue?vue&type=script&lang=js&"
import style0 from "./Zhuizong.vue?vue&type=style&index=0&id=1794ac92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1794ac92",
  null
  
)

export default component.exports